import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";
import { isDarkColor } from "../../helpers/color.helper";
import { PreviewElement } from "./components/previewElement";

const Preview = () => {
    const { t } = useGranite();
    const { selectedColor, selectedFinish, selectedVolume } =
        usePaintConfiguratorContext();

    if (!selectedColor) return null;

    return (
        <div
            className={cn(
                "tw:rounded-sm tw:relative tw:shadow-md",
                "tw:md:overflow-hidden tw:md:aspect-square"
            )}
            style={{ backgroundColor: `#${selectedColor.hexValue}` }}
        >
            <div
                className={cn(
                    "tw:w-full",
                    isDarkColor(selectedColor.hexValue)
                        ? "tw:text-background"
                        : "tw:text-foreground",
                    "tw:md:bottom-0 tw:md:absolute"
                )}
            >
                <div
                    className={cn(
                        "tw:flex tw:flex-row-reverse tw:justify-end tw:md:justify-normal tw:md:flex-col"
                    )}
                >
                    {selectedVolume && (
                        <PreviewElement
                            label={t("paintConfigurator.volume.label")}
                            value={selectedVolume.volume.value.toUpperCase()}
                            animate={true}
                        />
                    )}
                    {selectedFinish && (
                        <PreviewElement
                            label={t("paintConfigurator.finish.label")}
                            value={selectedFinish.value}
                            animate={!selectedVolume}
                        />
                    )}
                    {selectedColor && (
                        <PreviewElement
                            label={t("paintConfigurator.color.label")}
                            value={selectedColor.name}
                            animate={!selectedFinish && !selectedVolume}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export { Preview };
